import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from '../../store/actions';
import './SectionFour.css';
import ScrollToNext from '../ScrollToNext/ScrollToNext';
import { getLocale } from '../../utils/locale';

class SectionFour extends Component {

  toggleRegistration = () => {
    var countryCode = getLocale().split('-')[1];
    
    if(countryCode === 'id'){
      this.props.openPopUp('PopUpIDRMarketClosure')
    }
    else{
      this.props.openPopUp('Registration')
    }
  }

  backgroundImage(lang) {
    const locale = lang.split('-')[0];

    switch(locale){
      case 'zh' : return 'CN';
      case 'vi' : return 'VN';
      case 'th' : return 'TH';
      default: return 'EN';
    };
  }

  render() {
    // const { formatMessage } = this.props.intl;
    return (
      <div className="section4-content section-four">
        <div className="section-four-content">
          <div className = {"section4-img-" + this.backgroundImage(getLocale())}/>
        </div>
        <ScrollToNext pageSelector=".section-five" arrow="blue"/>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {
    openPopUp: (type) => dispatch(actions.openPopUp(type))
  };
};

const mapStateToProps = state => {
  return {
    mobile: state.responsiveui.mobile
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SectionFour)
);